import {
    Vue,
    store,
    i18n,
    languages,
    routes
} from './config/index'

import VueScrollReveal from 'vue-scroll-reveal'

Vue.use(VueScrollReveal, {
    class: 'reveal',
    duration: 500
})

import moment from 'moment'
window.moment = moment

import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    routes,
    mode: 'history', // prevent URLs from having # sign
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            const position = {}
            let section = to.params.section

            // scroll to the element if exists on the page
            if (section) {
                position.selector = '#' + section

                if (document.querySelector(position.selector)) {
                    return position
                }
            }

            // Scroll to top
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    let locale = '',
        localeUrlSegment = to.path.split('/'),
        currentLocale = i18n.locale()

    localeUrlSegment.shift()
    locale = localeUrlSegment[0]

    if (locale === '') {
        locale = currentLocale
    }

    if (locale && languages.has(locale) === false) {
        next({
            name: 'index',
            params: { locale: currentLocale }
        })
    } else {
        i18n.set(locale)

        to.params.locale = locale
    }

    if (from.name) {
        store.state.loading.status = true

        next()

        // TODO: Force hide navigation

        setTimeout(function () {
            next()
        }, store.state.loading.duration)
    } else {
        next()
    }
})

router.afterEach(() => {
    store.state.loading.status = false
})

import DropdownMenu from './components/modules/Dropdown.vue'
import VideoItem from './components/modules/Video.vue'
import Calendar from './components/modules/Calendar.vue'

Vue.component('dropdown-menu', DropdownMenu)
Vue.component('video-item', VideoItem)
Vue.component('calendar', Calendar)

import Application from './components/App'

const App = new Vue({
    el: '#app',

    components: {
        Application
    },

    computed: {
        Config() {
            return window.Config
        }
    },

    store,
    router
})

window.App = App
window.router = router
